<template>
	<div class="tree">
		<ul class="tree-list">
			<ReBranchTreeNode :node="treeData" />
		</ul>
	</div>
</template>

<script>
import ReBranchTreeNode from "./ReBranchTreeNode";

export default {
	props: {
		treeData: Object
	},
	components: {
		ReBranchTreeNode
	}
};
</script>

<style>
	.tree > ul{list-style: none;}
	.tree-list ul {
		padding-left: 16px;
		margin: 6px 0;
		list-style: none;
	}
	.tree ul li::before{
		font: normal normal normal 1em/1 Nucleo;
		margin-right: 10px;
		position: relative;
    	bottom: -5px;
		content: "\EA33";
		display: inline-block;
		color: #01B0E0 !important;
	}
	.tree ul li.root::before{
		content: "";
		background-image: url('/img/icons/hierarchy.svg');
		width: 19px;
		height: 20px;
	}
</style>